import ListingsGrid from "../components/ListingsLayout";
import SearchBar from "../components/searchBar";

const DonationListings = () => {
  return (
    <div>
      <SearchBar />
      <ListingsGrid />
    </div>
  );
}

export default DonationListings;